export const environment = {
  apiUrl: ' https://gate-importer.dev.vcl-core-apps.schueco.dev',
  //apiUrl: 'http://localhost:1100'
  //apiUrl: 'https://localhost:1101'
};
